module.exports = __webpack_public_path__ + "img/ico-linkedin.50adac1e.svg";